import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { TOKENS } from "./tokens";

/**
 * `cta = { label, onClick, icon? }` — optional call-to-action button.
 */
const EmptyState = ({ icon, title, body, cta }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      py: 6,
      px: 3,
    }}
  >
    <Box
      sx={{
        width: 52,
        height: 52,
        borderRadius: `${TOKENS.radiusS}px`,
        background: TOKENS.bgSunken,
        color: TOKENS.fg3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mb: 1.5,
        border: `1px solid ${TOKENS.borderSubtle}`,
      }}
    >
      {icon}
    </Box>
    <Typography sx={{ fontSize: 15, fontWeight: 500, color: TOKENS.fg1 }}>
      {title}
    </Typography>
    {body ? (
      <Typography sx={{ fontSize: 13, color: TOKENS.fg3, mt: 0.5, maxWidth: 360 }}>
        {body}
      </Typography>
    ) : null}
    {cta ? (
      <Button
        onClick={cta.onClick}
        startIcon={cta.icon}
        sx={{
          mt: 2,
          textTransform: "none",
          fontWeight: 600,
          color: "#fff",
          background: TOKENS.primary,
          borderRadius: `${TOKENS.radiusXs}px`,
          px: 2,
          "&:hover": { background: TOKENS.primaryHover },
        }}
      >
        {cta.label}
      </Button>
    ) : null}
  </Box>
);

export default EmptyState;
